import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import { GridDataCell } from './grid-data-cell';

const propTypes = {
  headerDefs: PropTypes.array,
  data: PropTypes.any,
  defaultCellStyle: PropTypes.object,
  defaultRowStyle: PropTypes.object,
  index: PropTypes.number,
  isHover: PropTypes.bool,
  filters: PropTypes.object,
  rowBg: PropTypes.string,
  rowAlternateBg: PropTypes.string,
  rowHoverBg: PropTypes.string,
  showEllipsis: PropTypes.bool,
  dataId: PropTypes.string,
  onClickEllipsis: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onClickCell: PropTypes.func,
  enableHover: PropTypes.bool,
  gridPosition: PropTypes.string,
  addEllipsisCol: PropTypes.bool,
  theme: PropTypes.object
};

const defaultProps = {
  defaultCellStyle: {},
  defaultRowStyle: {},
  gridPosition: '',
  addEllipsisCol: false
};

const GridRow = (props) => {
  const {
    headerDefs,
    defaultCellStyle,
    defaultRowStyle,
    filters,
    data,
    index,
    rowBg,
    rowAlternateBg,
    rowHoverBg,
    showEllipsis,
    enableHover,
    gridPosition,
    theme
  } = props;

  const styles = StyleSheet.create({
    rows: {
      display: 'flex'
    },
    bgStyles: {
      ':nth-child(odd)': { background: rowAlternateBg },
      ':nth-child(even)': { background: rowBg }
    },
    hoverBgStyles: { background: rowHoverBg }
  });

  let color = rowBg;
  if (props.index % 2 === 0) {
    color = rowAlternateBg;
  }

  if (props.isHover) {
    color = rowHoverBg;
  }

  if (props.isSelected) {
    color = 'rgba(0, 128, 255, 0.5)';
  }

  const { gridRowsFontSize, gridRowsBottomBorderColor } = theme;

  const cells = [];
  if (!showEllipsis) {
    headerDefs.forEach((el, idx) => {
      if (el.visible) {
        cells.push(
          <GridDataCell
            dataId={`${props.dataId}_${idx}_WORLD`}
            key={`${props.dataId}_${idx}`}
            recordId={props.recordId}
            headerDef={el}
            data={data[el.field]}
            filters={filters}
            defaultCellStyle={defaultCellStyle}
            colCellsStyle={el.colCellsStyles}
            onClickCell={props.onClickCell}
            rowIndex={props.index}
            style={{
              background: color,
              fontSize: gridRowsFontSize,
              borderBottom: props.isSelected ? '2px solid #0080ff' : `1px solid ${gridRowsBottomBorderColor}`,
              borderTop: props.isSelected ? '2px solid #0080ff' : 'none',
              borderLeft: (props.isSelected && idx === 0 && el.pin === 'left')
                ? '3px solid #0080FF'
                : 'none'
            }}
            gridPosition={gridPosition}
            theme={theme}
          />
        );
      }
    });
    if (props.addEllipsisCol) {
      cells.push(
        <div
          className='data-cells'
          key={props.dataId}
          style={{
            // maxWidth: '40px',
            // minWidth: '40px',
            width: '40px',
            height: defaultRowStyle.height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: color,
            flexGrow: '0',
            flexShrink: '0',
            borderBottom: props.isSelected ? '2px solid #0080ff' : `1px solid ${gridRowsBottomBorderColor}`,
            borderTop: props.isSelected ? '2px solid #0080ff' : 'none',
            borderRight: props.isSelected ? '3px solid #0080FF' : 'none',
            fontSize: gridRowsFontSize
          }}
          onClick={(e) => {
            props.onClickEllipsis(e, props.index);
          }}
        >
          <i className='fa fa-ellipsis-h' />
        </div>
      );
    }
  }

  if (showEllipsis) {
    cells.push(
      <div
        className='data-cells'
        key={props.dataId}
        style={{
          // maxWidth: '40px',
          // minWidth: '40px',
          width: '40px',
          height: defaultRowStyle.height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: color,
          borderBottom: props.isSelected ? '2px solid #0080ff' : `1px solid ${gridRowsBottomBorderColor}`,
          borderTop: props.isSelected ? '2px solid #0080ff' : 'none',
          borderRight: props.isSelected ? '3px solid #0080FF' : 'none',
          fontSize: gridRowsFontSize
        }}
        onClick={(e) => {
          props.onClickEllipsis(e, props.index);
        }}
      >
        <i className='fa fa-ellipsis-h' />
      </div>
    );
  }

  return (
    <div
      key={`props.dataId`}
      className={css(styles.rows)}
      style={{
        ...defaultRowStyle
      }}
      onMouseEnter={() => {
        if (enableHover) {
          props.onRowMouseOver(index);
        }
      }}
    >
      {cells}
    </div>
  );
};

GridRow.propTypes = propTypes;
GridRow.defaultProps = defaultProps;

export { GridRow };
